/*
 * Copyright (c) Worldline 2023.
 */

import {Component} from '@angular/core';
import {ResumeComponent} from "../resume/resume.component";

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html'
})
export class RedirectComponent extends ResumeComponent {

    override ngOnInit(): void {
        super.ngOnInit()

        const that = this

        //timeout (10 sec) before redirection
        setTimeout(() => {
            that.exit()
        }, 10000)
    }

    exit() {
        this.redirectionService.exit(this.sessionService.getUrlOk());
    };

}
